import MainVue from '../../main-vue';
import { LoginModalMixin } from '../../section-specific/applications/mixins/loginModal';
import AiAssitant from '../../components/component.ai-chat.vue';

new MainVue({
    mixins: [LoginModalMixin],
    el: "#app",
    components: {
        'ai-assistant': AiAssitant
    },
    data: function() {
        return {
            
        }
    },
    created () {},
    methods: {}
});